import moment from 'moment';

/**
 * Correctly format the usage start date for a school.
 *
 * if school.usage_start_date is not defined - use the most recent past August 1st as the usage_start_date in the admin snapshot
 *
 * If school.usage_start_date is defined - use the most recent month and date (not the year) of the last year as the
 *  usage_start_date in the admin snapshot
 *
 * Ex. school.usage_start_date = "2019-03-01" → use "2021-03-01" as usage_start_date
 * Ex. school.usage_start_date = "2020-08-01" → use "2020-08-01" as usage_start_date
 *
 * @param {*} adminUsageStartDate start date for usage information for school.
 * @returns the correctly formatted usage starte date for a school.
 */
export function formatUsageStartDate(adminUsageStartDate) {
  if (adminUsageStartDate) {
    const usageStartDateMonth = moment.utc(adminUsageStartDate).month();
    const usageStartDate = moment.utc(adminUsageStartDate).date();
    const isUsageMonthOver = moment().month() + 1 > usageStartDateMonth;

    return isUsageMonthOver
      ? moment()
          .set({
            month: usageStartDateMonth,
            date: usageStartDate,
            year: moment().year(),
          })
          .startOf('day')
          .format('YYYY-MM-DD HH:mm:ss')
      : moment()
          .subtract(1, 'year')
          .set({ month: usageStartDateMonth, date: usageStartDate })
          .startOf('day')
          .format('YYYY-MM-DD HH:mm:ss');
  } else {
    const august = moment('08-01', 'MM-DD');
    const recentPastAugust = august < moment() ? august : august.subtract(1,'years');
    return recentPastAugust.format('YYYY-MM-DD HH:mm:ss');
  }
}
